export default "__VITE_ASSET__ZpF11A4o__"